import { GetServerSidePropsContext, NextPageContext, PreviewData } from 'next';
import { ParsedUrlQuery } from 'querystring';
import { parseCookies } from 'nookies';
import { propOr } from 'ramda';

export interface Auth {
  token: string;
  environment: 'production' | 'integration';
}

export const getAuthToken = (
  context:
    | GetServerSidePropsContext<ParsedUrlQuery, PreviewData>
    | NextPageContext
): string | null => {
  const authCookie = JSON.parse(
    propOr(null, 'authDomainSSO', parseCookies(context))
  ) as Auth | null;

  return propOr(null, 'token', authCookie);
};

export const getAuthCookies = (
  context:
    | GetServerSidePropsContext<ParsedUrlQuery, PreviewData>
    | NextPageContext
) =>
  JSON.parse(
    propOr(null, 'authDomainSSO', parseCookies(context))
  ) as Auth | null;
